import React, { useEffect } from 'react'
import styles from './style.module.scss'
import Navbar from '../../Components/Navbar'
import { Helmet } from 'react-helmet'
import Copyrights from '../../Components/Copyrights'

import { HeaderImg } from '../../Components/Header'
import headerImg from '../../Assets/headerImgs/abd.jpg'

import clientsImg1 from '../../Assets/clients/Galadari-Logo-2.svg'
import clientsImg2 from '../../Assets/clients/HiltonLogo.svg'
import clientsImg3 from '../../Assets/clients/The Kingsbury Colombo Sri Lanka.svg'
import clientsImg4 from '../../Assets/clients/mountLaviniaHotel.png'
import clientsImg5 from '../../Assets/clients/TAJ-Samudra-Logo-e1661106759133.png'
import clientsImg6 from '../../Assets/clients/unilever-logo.svg'
import clientsImg7 from '../../Assets/clients/KeellsLogo.png'
import clientsImg8 from '../../Assets/clients/Elephant_House_logo.png'
import clientsImg9 from '../../Assets/clients/logo-fonterra-png-abogo-productions-dodge-fonterra-500.jpg'
import clientsImg10 from '../../Assets/clients/srilankan-catering.png'
import clientsImg11 from '../../Assets/clients/dominos-pizza.png'
import clientsImg12 from '../../Assets/clients/perera-and-sons.svg'
import clientsImg13 from '../../Assets/clients/fab-logo.jpeg'
import clientsImg14 from '../../Assets/clients/14.jpg'

import Aos from 'aos'
import 'aos/dist/aos.css';

const ClientsPage = () => {

  useEffect(() => {
    Aos.init({
      duration: 1000
    })
  }, [])

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Clients</title>
      </Helmet>
      <Navbar active="clients" />
      <HeaderImg img={headerImg} alt="headerImg" />
      <div className={styles.clientsImgCont}>
        <img src={clientsImg1} alt="clientsImg1" data-aos="fade-up" />
        <img src={clientsImg2} alt="clientsImg2" data-aos="fade-up" />
        <img src={clientsImg3} alt="clientsImg3" data-aos="fade-up" />
        <img src={clientsImg4} alt="clientsImg4" data-aos="fade-up" />
        <img src={clientsImg5} alt="clientsImg5" data-aos="fade-up" />
        <img src={clientsImg6} alt="clientsImg6" data-aos="fade-up" />
        <img src={clientsImg7} alt="clientsImg7" data-aos="fade-up" />
        <img src={clientsImg8} alt="clientsImg8" data-aos="fade-up" />
        <img src={clientsImg9} alt="clientsImg9" data-aos="fade-up" />
        <img src={clientsImg10} alt="clientsImg10" data-aos="fade-up" />
        <img src={clientsImg11} alt="clientsImg11" data-aos="fade-up" />
        <img src={clientsImg12} alt="clientsImg12" data-aos="fade-up" />
        <img src={clientsImg13} alt="clientsImg13" data-aos="fade-up" />
        <img src={clientsImg14} alt="clientsImg14" data-aos="fade-up" />
      </div>
      <Copyrights />
    </div>
  )
}

export default ClientsPage